import "./url-parameters.js";
import { startRouter } from "./home/router.js";
import { renderHome } from "./home/render-home.js";
import { renderAppPage } from "./home/render-app.js";
import { startAppInviteInbox } from "./home/app-invite-inbox.js";

const root = document.getElementById("app");

function render(route) {
  if (!root) return;

  if (route.name === "app") {
    document.title = "Welcome2Life";
    renderAppPage(root, route.appId);
    const titleEl = root.querySelector(".app-topbar-title");
    if (titleEl && titleEl.textContent) {
      document.title = `${titleEl.textContent} · Welcome2Life`;
    }
    return;
  }

  document.title = "Welcome2Life";
  renderHome(root);
}

startRouter(render);
startAppInviteInbox();
